module.exports = __webpack_public_path__ + "static/media/10620298_10205137692542449_5834681488436813065_o.72107a15.jpg";